module.exports = __webpack_public_path__ + "components/flag/static/square/tw-2c5392b6061314565768a8b6e5f1c2ac.svg";